<template>
  <div>
    <div class="boxs">
      <div class="top">{{ item.fzr }}</div>
      <div class="content">
        <Row>
          <Col :span="24"><span class="title">队长:</span>{{ item.fzr }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">职位:</span>{{ item.duty }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">车牌:</span>{{ item.carno }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">联系方式:</span>{{ item.phone }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">性别:</span>{{ item.sex==='1'?'男':'女' }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">所属地区:</span>{{ item.unitName }}</Col>
        </Row>
      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  name: "WarehouseWindows"
}
</script>

<style scoped lang="less">
.boxs {
  overflow: auto;

  .top {
    color: #ffffff;
    height: 4vh;
    line-height: 4vh;
    padding-left: .5rem;
    font-size: .7rem;
  }

  .content {
    padding-left: .5rem;
    color: #ffffff;
    font-size: .7rem;
    overflow: auto;
    height: 20vh;

    &::-webkit-scrollbar {
      display: none;
    }

    .ivu-col {
      line-height: 1.4rem;
    }

    .title {
      color: #72aefa;
    }
  }
}
</style>
